import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BusinessUser } from '@models/businesses';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@UntilDestroy()
@Component({
	selector: 'contact-admin',
	templateUrl: './contact-admin.component.html',
	styleUrls: ['./contact-admin.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ContactAdminComponent implements OnInit {
	@Select(BusinessUsersState.getAdmins) admins$: Observable<BusinessUser[]>;

	public displayedColumns = ['name', 'email'];

	public adminUsersDataSource$: Observable<{ name: string; email: string }[]>;

	ngOnInit() {
		this.adminUsersDataSource$ = this.admins$.pipe(
			untilDestroyed(this),
			map((admins) => {
				return admins.map((admin) => {
					return {
						name: `${admin.firstName ?? ''} ${admin.lastName ?? ''}`,
						email: admin.email,
					};
				});
			}),
		);
	}
}
